<template>
  <v-card class="transparent elevation-0 pa-3">
    <!-- Page Title -->
    <v-card-title v-if="title" class="px-0">
      <div class="d-flex align-center justify-space-between">
        {{ title }}
      </div>
    </v-card-title>
    <!-- Mini Charts -->
    <v-row class="py-2">
      <slot name="charts" />
    </v-row>

    <!-- Tabs for Table and Card View -->
    <v-card class="elevation-0" outlined>
      <v-tabs v-model="activeTab" right class="transparent">
        <div class="actions pl-1 d-flex flex-row justify-center align-center">
          <slot name="actions" />
        </div>
        <v-spacer />
        <v-tab v-if="view.includes('card')">
          <v-icon small>mdi-view-grid</v-icon>
        </v-tab>
        <v-tab v-if="view.includes('table')">
          <v-icon small> mdi-table</v-icon>
        </v-tab>
      </v-tabs>
    </v-card>

    <v-tabs-window v-model="activeTab" class="transparent">
      <v-tabs-window-item v-if="view.includes('card')">
        <v-row class="pa-2 pt-4">
          <v-col
            class="ma-0 pa-1"
            v-for="(item, index) in items"
            :key="index"
            :cols="cols"
          >
            <slot name="card" :item="item"></slot>
          </v-col>
        </v-row>
      </v-tabs-window-item>
      <v-tabs-window-item v-if="view.includes('table')">
        <v-data-table
          class="mt-2 list-table"
          :headers="headers"
          :items="items"
          fixed-header
          hover
          :show-select="headers.some((header) => header.title === 'Select')"
        >
          <template #item="{ item }">
            <slot name="row" :item="item" :headers="headers" />
          </template>
        </v-data-table>
      </v-tabs-window-item>
    </v-tabs-window>
  </v-card>
</template>
  
  <script>
export default {
  props: {
    title: {
      type: String,
    },
    row: {
      type: Object,
      default: () => ({ name: "Example", value: 100 }),
    },
    cols: {
      type: Number,
      default: 6,
    },
    items: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Array,
      default: () => [],
    },
    view: {
      type: Array,
      default: () => ["table", "card"],
    },
  },
  data() {
    return {
      search: "",
      activeTab: this.view.includes("card") ? 0 : 1,
      charts: [null, null, null],
    };
  },
  mounted() {},
  methods: {},
};
</script>
  
  <style lang="scss" >
.chart-container {
  width: 100%;
  height: 100%;
  min-height: 220px;
}

.list-table {
  tr {
    cursor: pointer !important;
  }
}
</style>
  